module.exports = __webpack_public_path__ + "img/Step15.36e63193.png";